<div class="login-container">
  <app-header-title
    [title]="'Redefinir senha'"
    [link]="'/login'"
  ></app-header-title>

  <form class="login-form">
    <span
      >Confirme o e-mail para enviarmos as intruções de redefinição da
      senha.</span
    >
    <div class="form-group">
      <input
        id="email"
        type="email"
        placeholder="Digite seu e-mail"
        [formControl]="form"
        class="form-control"
      />
      @if(form.get('email')?.invalid && form.get('email')?.touched){
      <small class="error"> E-mail é obrigatório </small>
      }
    </div>
  </form>
  <div class="login-footer">
    <button
      (click)="submit()"
      type="submit"
      [disabled]="form.invalid"
      class="btn btn-primary"
    >
      Enviar
    </button>
  </div>
</div>
